module.exports = __webpack_public_path__ + "static/Organigramm 2-c399e24941d58a1bdc656fca2615fac3.jpg";